import { render } from "./projecthealth.vue?vue&type=template&id=b71658d2"
import script from "./projecthealth.vue?vue&type=script&lang=js"
export * from "./projecthealth.vue?vue&type=script&lang=js"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__